import { Draggable, Droppable } from "react-beautiful-dnd";
import memoizeOne from "memoize-one";
import { Link } from "react-router-dom";
import PageToEighth from "../../../shared/eighth";
import { OnboardingStep5ClassName } from "./ducks/reducer";
import Moment from "react-moment";
import Scene from "./scene";
import { formatTimeFromMinutes } from "../../../shared/format-time";

const Day = ({
    filmId,
    index,
    toggleSelection,
    toggleSelectionInGroup,
    multiSelectTo,
    readOnly,
    day,
    truncateSummary,
    colorCode,
    deleteShootingDay,
    selectedSceneIds,
    draggingSceneId
}) => {

    const getDayStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        //padding: grid * 2,
        //margin: `0 0 ${grid}px 0`,
        borderRadius: "5px",
        // change background colour if dragging
        background: isDragging ? "#222E44" : "#947eed",
        color: isDragging ? "white" : "#182231",
        // styles we need to apply on draggables
        ...draggableStyle
    });

    type SceneIdMap = {
        [sceneId: string]: true;
    };

    const getSelectedMap = memoizeOne((selectedSceneIds: string[]) =>
        selectedSceneIds.reduce(
            (previous: SceneIdMap, current: string): SceneIdMap => {
                previous[current] = true;
                return previous;
            },
            {}
        )
    );

    return (
        <Draggable
            key={day.number}
            draggableId={day.number + ""}
            index={index}
            isDragDisabled={readOnly || day.fixed}
        >
            {(draggableProvided, draggableSapshot) => (
                <Droppable droppableId={day.number + ""} type="scene">
                    {(provided, snapshot) => (
                        <tbody
                            key={index}
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            className="shooting-order-day"
                        >
                            <tr
                                ref={draggableProvided.innerRef}
                                className={index === 0 ? OnboardingStep5ClassName : ""}
                                {...draggableProvided.draggableProps}
                                {...draggableProvided.dragHandleProps}
                                style={getDayStyle(
                                    draggableSapshot.isDragging,
                                    draggableProvided.draggableProps.style
                                )}
                            >
                                <td colSpan={3}>
                                    {!readOnly && !day.fixed && <i className="material-icons">drag_indicator</i>}
                                    <Link to={`${day.id}/edit`}>Day {day.number} &nbsp; &nbsp;</Link>
                                    {day.date && (
                                        <Moment format="Do MMMM YYYY">
                                            {day.date}
                                        </Moment>
                                    )}
                                </td>
                                <td colSpan={3}></td>
                                <td>
                                    <PageToEighth
                                        page={day.scenes?.reduce(function (a, b) {
                                            return a + b.pageLength;
                                        }, 0)}
                                    ></PageToEighth>
                                </td>
                                <td>
                                    {day.scenes ? Math.round(
                                        day.scenes?.reduce(function (a, b) {
                                            return a + b.shootDays;
                                        }, 0) * 10
                                    ) / 10 : ""}
                                </td>
                                <td>{day.scenes?.length ? formatTimeFromMinutes(
                                    day.scenes?.reduce(function (a, b) {
                                        if (b.estimatedShootingDurationMinutes) {
                                            return a + b.estimatedShootingDurationMinutes;
                                        }

                                        return a;
                                    }, 0)
                                ) : ""}</td>
                                <td></td>
                                <td>
                                    {(!day.scenes || day.scenes?.length === 0) && (
                                        <a onClick={() => deleteShootingDay(day.number)}>
                                            {!readOnly && <i className="material-icons">delete</i>}
                                        </a>
                                    )}
                                </td>
                            </tr>
                            {(day.scenes || []).map((scene, index) => {

                                const selectionMap = getSelectedMap(
                                    selectedSceneIds || []
                                );
                                const isSelected = selectionMap
                                    ? selectionMap[scene.sceneId]
                                    : false;
                                const isGhosting =
                                    isSelected &&
                                    draggingSceneId &&
                                    draggingSceneId !== scene.sceneId;
                                return (
                                    <Scene
                                        filmId={filmId}
                                        index={index}
                                        scene={scene}
                                        toggleSelection={toggleSelection}
                                        toggleSelectionInGroup={toggleSelectionInGroup}
                                        multiSelectTo={multiSelectTo}
                                        isSelected={isSelected}
                                        isGhosting={snapshot.isDragging}
                                        readOnly={readOnly}
                                        truncateSummary={truncateSummary}
                                        colorCode={colorCode} />
                                );

                            })}
                            {provided.placeholder}
                            <tr style={{ backgroundColor: "#162135" }}>
                                <td style={{ borderBottomWidth: 0 }} colSpan={11}></td>
                            </tr>
                        </tbody>
                    )}
                </Droppable>
            )}
        </Draggable>
    );
};

export default Day;
